var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3706 5.8125C10.7808 5.8125 7.87061 8.72265 7.87061 12.3125C7.87061 15.9024 10.7808 18.8125 14.3706 18.8125C16.0071 18.8125 17.5002 18.209 18.6433 17.211L19.9587 18.7176C18.4652 20.0215 16.509 20.8125 14.3706 20.8125C9.67618 20.8125 5.87061 17.0069 5.87061 12.3125C5.87061 7.61808 9.67618 3.8125 14.3706 3.8125C16.509 3.8125 18.4652 4.60347 19.9587 5.90741L18.6433 7.414C17.5002 6.416 16.0071 5.8125 14.3706 5.8125Z",
    fill: "#2771bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8706 11.3125H3.87061V9.3125H13.8706V11.3125Z",
    fill: "#2771bb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8706 15.3125H3.87061V13.3125H11.8706V15.3125Z",
    fill: "#2771bb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.fcc6214992f671e2eaf7bff028a8fbe8.svg";
export { ForwardRef as ReactComponent };